import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Client } from './types'

export const CLIENTS_QUERY: TypedDocumentNode<
  { clients: Client[] },
  { search?: string; limit?: number; offset?: number }
> = gql`
  query Clients($search: String, $limit: Int, $offset: Int) {
    clients(search: $search, limit: $limit, offset: $offset) {
      id name path blocked observations created_at updated_at
    }
  }
`

export const CLIENT_QUERY: TypedDocumentNode<{ client: Client | null }, { id: string }> = gql`
  query Client($id: ID!) {
    client(id: $id) {
      id name path blocked observations created_at updated_at
    }
  }
`
